import { rateLabel, type LineFxSnapshot, type PiLineInput } from "@hisense/shared";
import { formatUnitPrice } from "@/domain/money";

type FxInput = NonNullable<PiLineInput["fxConversion"]>;

/**
 * Một dòng chữ nói rõ đơn giá đến từ đâu (yêu cầu v1.8 mục 6.4): "RMB 0.3200 → 1 USD = 6.6 RMB". Đủ tiền gốc, giá gốc, tỷ giá có
 * chiều — để người đọc PI không phải đoán con số đã được quy đổi hay gõ tay.
 */
export function fxNote(fx: LineFxSnapshot | FxInput): string {
  const parts = fxNoteParts(fx);
  return `${parts.source} · ${parts.rate}`;
}

/** Hai mảnh ngắn cho ô hẹp: "USD 0.2280" và "1 USD = 6.6 RMB". */
export function fxNoteParts(fx: LineFxSnapshot | FxInput): { source: string; rate: string } {
  const sourcePrice =
    typeof fx.sourceUnitPrice === "number"
      ? formatUnitPrice(fx.sourceUnitPrice, fx.sourceCurrency, false)
      : String(fx.sourceUnitPrice);
  return { source: `${fx.sourceCurrency} ${sourcePrice}`, rate: rateLabel(fx) };
}
